import React from 'react';
import {Image, PageHeader} from 'antd';

const Design = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Дизайн"
            />
            <p>Перед началом работы над проектом был сделан прототип - макет в Figma</p>
            <Image
                width={1000}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601231889/documentation/Screenshot_2020-09-27_at_21.37.23_bpzcke.png"
            /><br/><br/>
            <p>Ссылка на макет:</p>
            <a href="https://www.figma.com/file/tlNrlB61AmUtYJdY5ohig6/RSShcedule?node-id=0%3A1">https://www.figma.com/file/tlNrlB61AmUtYJdY5ohig6/RSShcedule?node-id=0%3A1</a><br/><br/>
            <p>В ходе работы часть элементов доработали/добавили, от части отказались</p>
            <p>Например, решено было не красить строки таблицы в разные цвета, так как из-за этого приложение выглядело перегруженным</p>
        </>
    );
};

export default Design;